<script setup>
import { onMounted} from 'vue';
import { useUserAuthStore } from "./stores/user_auth_store";
import router from './router';
import { useBreadCrumbStore } from '@/stores/breadcrumb_store';

const authStore = useUserAuthStore()
const breadcrumbStore = useBreadCrumbStore();

onMounted(() => {
  console.log("First reloads")
  authStore.getUserToken();

  //set the router after each
  router.afterEach((to) => {
    // Auto-generate basic breadcrumb from path
    console.log("BREAD CRUMB TO: ", to.path);
    const segments = to.path.split('/').filter(Boolean);
    const breadcrumbs = segments.map((segment, idx) => ({
      label: decodeURIComponent(segment),
      to: '/' + segments.slice(0, idx + 1).join('/')
    }));

    console.log("BREAD CRUMBs: ", breadcrumbs);
    breadcrumbStore.setBreadcrumb(breadcrumbs);
  });
})
</script>

<template>
  <Toast />
  <ConfirmPopup></ConfirmPopup>
  <router-view></router-view>
</template>
